import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";

export default Backbone.View.extend({
  initialize: function (opts) {
    console.log("init blog listing page");

    var self = this;
    self.$content = self.$el;

    if (localStorage.getItem("scrollAfterFilter") === "true") {
      self.scrollAfterFilterHandle();
      localStorage.removeItem("scrollAfterFilter"); 
    }
  },

  events: {
    "click .filter-values li": "scrollAfterFilterHandle",
  },

  destroy: function () {
    var self = this;
    self.undelegateEvents();
  },

  responsive: function () {
    var self = this;
    ORW.utilities.mediaCheck(
      function () {
        // Desktop actions
      },
      function () {
        // Mobile actions
      }
    );
  },

  isMobile: function () {
    return ORW.responsive === "small";
  },

  scrollAfterFilterHandle: function () {
    const filteringWrapper = document.getElementById("filtering-wrapper");

    localStorage.setItem("scrollAfterFilter", "true");

    if (filteringWrapper) {
      const wrapperPosition =
        filteringWrapper.getBoundingClientRect().top + window.scrollY;
      const offset = window.innerWidth <= 768 ? 0 : 100;
      window.scrollTo({ top: wrapperPosition - offset, behavior: "smooth" });
    }
  },
});
